/**
 * Armchair Epics - Birthday Datepicker  v4
 *
 * Custom calendar for .birthday-picker fields.
 * Header = Month dropdown + Year dropdown.
 * Uses mousedown (not click) for outside-close so native <select>
 * dropdowns don't accidentally dismiss the panel.
 * Persists selection to localStorage so it pre-fills across product pages.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'ae_birthday';

  var MONTHS = ['January','February','March','April','May','June',
                'July','August','September','October','November','December'];
  var DOW    = ['Su','Mo','Tu','We','Th','Fr','Sa'];
  var MIN_YEAR = 1900;
  var MAX_YEAR = new Date().getFullYear() + 2;

  function sameDay(a, b) {
    return a && b &&
      a.getFullYear() === b.getFullYear() &&
      a.getMonth()    === b.getMonth()    &&
      a.getDate()     === b.getDate();
  }

  function formatDate(d) {
    return (d.getMonth() + 1) + '/' + d.getDate() + '/' + d.getFullYear();
  }

  function setIO(input, val) {
    var desc = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    desc.set.call(input, val);
    input.dispatchEvent(new Event('input',  { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ── Styles ────────────────────────────────────────────────────── */

  function injectStyles() {
    if (document.getElementById('ae-bday-styles')) return;
    var s = document.createElement('style');
    s.id  = 'ae-bday-styles';
    s.textContent = [
      '.ae-bday-trigger{display:block;width:100%;padding:13px 16px;background:#faf6ec;border:1px solid rgba(44,81,128,.18);border-radius:3px;font-size:17px;font-family:"EB Garamond",serif;color:rgba(106,100,128,.5);cursor:pointer;text-align:left;transition:border-color .15s,color .15s;box-sizing:border-box}',
      '.ae-bday-trigger--set{color:#31154d;border-color:rgba(49,21,77,.35)}',
      '.ae-bday-panel{display:none;position:absolute;left:0;top:calc(100% + 4px);z-index:9999;width:300px;background:#faf6ec;border:1px solid rgba(49,21,77,.25);border-radius:6px;box-shadow:0 4px 6px -1px rgba(30,26,20,.08),0 28px 60px -24px rgba(30,26,20,.55)}',
      '.ae-bday-panel--open{display:block}',
      '.ae-bday-header{display:flex;gap:8px;padding:14px 14px 10px;align-items:center}',
      '.ae-bday-select{flex:1;background:#faf6ec;border:1px solid rgba(49,21,77,.25);border-radius:3px;padding:6px 8px;font-size:16px;font-family:"EB Garamond",serif;font-style:italic;color:#1a1330;cursor:pointer}',
      '.ae-bday-grid{display:grid;grid-template-columns:repeat(7,1fr);padding:4px 10px 14px;gap:0}',
      '.ae-bday-dow{text-align:center;font-family:"Jost",sans-serif;font-size:10px;letter-spacing:.18em;text-transform:uppercase;color:rgba(106,100,128,.6);padding:6px 0 8px;line-height:1}',
      '.ae-bday-day{background:none;border:2px solid transparent;border-radius:50%;font-size:15px;width:34px;height:34px;cursor:pointer;font-family:"EB Garamond",serif;color:#1a1330;display:flex;align-items:center;justify-content:center;margin:1px auto;padding:0;transition:background .15s}',
      '.ae-bday-day:hover{background:rgba(49,21,77,.1)}',
      '.ae-bday-day--sel{background:#31154d!important;color:#faf6ec!important;border-color:#31154d!important;font-weight:600}',
    ].join('');
    document.head.appendChild(s);
  }

  /* ── Calendar grid ─────────────────────────────────────────────── */

  function buildMonth(grid, vy, vm, selDate, onPick) {
    grid.innerHTML = '';
    DOW.forEach(function (label) {
      var h = document.createElement('div');
      h.className = 'ae-bday-dow';
      h.textContent = label;
      grid.appendChild(h);
    });
    var firstDow    = new Date(vy, vm, 1).getDay();
    var daysInMonth = new Date(vy, vm + 1, 0).getDate();
    for (var b = 0; b < firstDow; b++) {
      grid.appendChild(document.createElement('div'));
    }
    for (var d = 1; d <= daysInMonth; d++) {
      var date = new Date(vy, vm, d);
      var btn  = document.createElement('button');
      btn.type        = 'button';
      btn.className   = 'ae-bday-day';
      btn.textContent = String(d);
      if (selDate && sameDay(date, selDate)) btn.classList.add('ae-bday-day--sel');
      (function (dt) {
        btn.addEventListener('click', function () { onPick(dt); });
      })(date);
      grid.appendChild(btn);
    }
  }

  /* ── Widget ────────────────────────────────────────────────────── */

  function createWidget(wrapper) {
    var ioInput = wrapper.querySelector('input[type="text"]');
    if (!ioInput) return;

    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.datepicker) {
      try { window.jQuery(wrapper).datepicker('destroy'); } catch (e) {}
    }

    ioInput.style.cssText = 'position:absolute;opacity:0;pointer-events:none;width:1px;height:1px;';
    var existing = wrapper.querySelector('.ui-datepicker-inline');
    if (existing) existing.style.display = 'none';

    var now       = new Date();
    var viewYear  = now.getFullYear() - 30;
    var viewMonth = now.getMonth();
    var selDate   = null;

    var wrapDiv = document.createElement('div');
    wrapDiv.style.cssText = 'position:relative;display:block;';

    var trigger = document.createElement('button');
    trigger.type      = 'button';
    trigger.className = 'ae-bday-trigger';
    trigger.textContent = 'Select date';

    var panel = document.createElement('div');
    panel.className = 'ae-bday-panel';

    var header = document.createElement('div');
    header.className = 'ae-bday-header';

    var monthSel = document.createElement('select');
    monthSel.className = 'ae-bday-select';
    MONTHS.forEach(function (name, i) {
      var opt = document.createElement('option');
      opt.value = String(i);
      opt.textContent = name;
      if (i === viewMonth) opt.selected = true;
      monthSel.appendChild(opt);
    });

    var yearSel = document.createElement('select');
    yearSel.className = 'ae-bday-select';
    for (var y = MAX_YEAR; y >= MIN_YEAR; y--) {
      var opt = document.createElement('option');
      opt.value = String(y);
      opt.textContent = String(y);
      if (y === viewYear) opt.selected = true;
      yearSel.appendChild(opt);
    }

    header.appendChild(monthSel);
    header.appendChild(yearSel);

    var grid = document.createElement('div');
    grid.className = 'ae-bday-grid';

    panel.appendChild(header);
    panel.appendChild(grid);
    wrapDiv.appendChild(trigger);
    wrapDiv.appendChild(panel);
    wrapper.appendChild(wrapDiv);

    function applyDate(dt) {
      selDate = dt;
      var display = formatDate(dt);
      trigger.textContent = display;
      trigger.classList.add('ae-bday-trigger--set');
      setIO(ioInput, display);
      localStorage.setItem(STORAGE_KEY, display);
    }

    function refresh() {
      buildMonth(grid, viewYear, viewMonth, selDate, function (dt) {
        applyDate(dt);
        closePanel();
      });
    }

    monthSel.addEventListener('change', function () {
      viewMonth = parseInt(monthSel.value, 10);
      refresh();
    });

    yearSel.addEventListener('change', function () {
      viewYear = parseInt(yearSel.value, 10);
      refresh();
    });

    function isOpen() { return panel.classList.contains('ae-bday-panel--open'); }
    function openPanel()  { panel.classList.add('ae-bday-panel--open'); }
    function closePanel() { panel.classList.remove('ae-bday-panel--open'); }

    trigger.addEventListener('click', function () {
      isOpen() ? closePanel() : openPanel();
    });

    /* Use mousedown — fires before browser handles native <select>,
       so wrapDiv.contains(e.target) correctly sees the select element
       and keeps the panel open when the user interacts with dropdowns. */
    document.addEventListener('mousedown', function (e) {
      if (isOpen() && !wrapDiv.contains(e.target)) {
        closePanel();
      }
    });

    /* ── Pre-fill from localStorage (cross-page persistence) ──────── */
    var stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      var parts = stored.match(/(\d{1,2})\/(\d{1,2})\/(\d{4})/);
      if (parts) {
        var storedDate = new Date(+parts[3], +parts[1] - 1, +parts[2]);
        if (!isNaN(storedDate.getTime())) {
          viewYear  = storedDate.getFullYear();
          viewMonth = storedDate.getMonth();
          applyDate(storedDate);
        }
      }
    }

    refresh();
  }

  /* ── Init ──────────────────────────────────────────────────────── */

  function init() {
    injectStyles();
    document.querySelectorAll('#infiniteoptions-container .birthday-picker').forEach(function (wrapper) {
      if (wrapper.dataset.aeBdayInit) return;
      wrapper.dataset.aeBdayInit = '1';
      createWidget(wrapper);
    });
  }

  var elapsed = 0;
  var timer = setInterval(function () {
    elapsed += 150;
    if (document.querySelector('#infiniteoptions-container .birthday-picker input[type="text"]')) {
      clearInterval(timer);
      init();
    }
    if (elapsed >= 8000) clearInterval(timer);
  }, 150);

})();